import { createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../api/api";

export const getFaqSectionThunk = createAsyncThunk(
  "faqsection/get",
  async (params) => {
    const { usertype } = params;
    let response = await api.get("getAllFaqSection" + "/" + usertype);
    return response.data;
  }
);

export const createFaqSectionThunk = createAsyncThunk(
  "faqsection/create",
  async (body) => {
    let response = await api.post("saveMasterFaqSection ", body);
    return response.data;
  }
);

export const updateFaqSectionThunk = createAsyncThunk(
  "faqsection/update",
  async (reqbody) => {
    // const {body } = reqbody; // remove _id from reqbody and create new object called body

    let response = await api.put("updateFaqSectionName", reqbody);
    return response.data;
  }
);

export const deleteFaqSectionThunk = createAsyncThunk(
  "faqsection/delete",
  async (data) => {
    let response = await api.delete(`deleteFaqSection/${data.sectionId}`);
    return response.data;
  }
);
